module.exports = __webpack_public_path__ + "assets/img/db5f2542133fdad4186b62685e3dcbcd.png";